

























import Vue from "vue";
import Component from "vue-class-component";
import BlogItem from "@/components/blog/item.vue";
import { TimeLineService, MeService } from "@/common/api";

@Component({
  name: "TimelineIndex",
  components: {
    BlogItem,
  },
})
export default class TimelineIndex extends Vue {
  public articles = [];
  public isFollowedGroup = false;
  public isLoading = true;

  params = {
    page: 1,
    perPage: 20,
  };

  async mounted() {
    await this.checkMemberIsFollowedGroup();
    this.isLoading = false;
  }

  public async checkMemberIsFollowedGroup() {
    try {
      const result = await MeService.meTotalFollowedGroup({});
      this.isFollowedGroup = result.data.totalFollowedGroup > 0;
    } catch (error) {
      console.log(error);
    }
  }

  public async infiniteHandler($state) {
    try {
      const result = await TimeLineService.userTimeline(this.params);
      if (result.data.articles.length > 0) {
        this.params.page += 1;
        this.articles.push.apply(this.articles, result.data.articles);
        $state.loaded();
      } else {
        $state.complete();
      }
    } catch {
      $state.complete();
    }
  }
}
